<template>
  <div>
    <Button :icon="processing ? 'pi pi-spin pi-spinner' : 'pi pi-ellipsis-v'"
            class="p-button-secondary p-button-raised action-button"
            :disabled="disabled || processing || !menuItems.length"
            @click="toggle"/>

    <Menu ref="menu"
          :model="menuItems"
          :popup="true"
          appendTo="body"/>
  </div>
</template>

<script>
import Menu from 'primevue/menu'

const STATUS_REVIEW_PENDING = 2
const STATUS_NEEDS_INFO = 3
const STATUS_APPROVED = 4
const STATUS_REJECTED = 5

export default {
  name: 'TenantApplicationActionsButton',
  components: {
    Menu,
  },
  emits: ['action'],
  props: {
    application: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event)
    },
    emitAction(action) {
      this.$emit('action', {
        action,
        application: this.application,
      })
    },
  },
  computed: {
    canSendOnboardingInvitation() {
      return !this.application?.converted_tenant_id
          && this.status === STATUS_APPROVED
    },
    status() {
      return Number(this.application?.status || 0)
    },

    canReview() {
      return !this.application?.converted_tenant_id && [
        STATUS_REVIEW_PENDING,
        STATUS_NEEDS_INFO,
      ].includes(this.status)
    },

    canMarkNeedsInfo() {
      return !this.application?.converted_tenant_id
          && this.status === STATUS_REVIEW_PENDING
    },

    canReturnToReview() {
      return !this.application?.converted_tenant_id && [
        STATUS_NEEDS_INFO,
        STATUS_APPROVED,
        STATUS_REJECTED,
      ].includes(this.status)
    },

    canDelete() {
      return !this.application?.converted_tenant_id
    },

    menuItems() {
      const items = []

      if (!this.application?.id) {
        return items
      }

      if (this.canReview) {
        items.push({
          label: this.$t('Approve'),
          icon: 'ti-check',
          command: () => this.emitAction('approve'),
        })

        if (this.canMarkNeedsInfo) {
          items.push({
            label: this.$t('tenantApplicationStatusNeedsInfo'),
            icon: 'ti-help-alt',
            command: () => this.emitAction('needs_info'),
          })
        }

        items.push({
          label: this.$t('Reject'),
          icon: 'ti-close',
          command: () => this.emitAction('reject'),
        })
      }

      if (this.canSendOnboardingInvitation) {
        items.push({
          label: this.$t(
              this.application?.onboarding_sent_at
                  ? 'tenantApplicationResendInvitation'
                  : 'tenantApplicationSendInvitation'
          ),
          icon: 'ti-email',
          command: () => this.emitAction('send_onboarding_invitation'),
        })
      }

      if (this.canReturnToReview) {
        items.push({
          label: this.$t('Return To Review'),
          icon: 'ti-back-left',
          command: () => this.emitAction('return_to_review'),
        })
      }

      if (this.canDelete) {
        if (items.length) {
          items.push({
            separator: true,
          })
        }

        items.push({
          label: this.$t('Delete'),
          icon: 'ti-trash',
          command: () => this.emitAction('delete'),
        })
      }

      return items
    },
  },
}
</script>